import React from 'react';
export function HeroSection() {
  return <section aria-label="P.E. READY presentation" className="bg-brand-dark text-brand-ink md:pt-20 pb-16 md:pb-24 px-4 relative pt-[10px]" data-id="element-115">
      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-116">
        <div className="flex flex-col items-center w-full pt-[15px] pb-[15px]" data-id="element-117">
          <div className="flex items-center gap-2 text-brand-gold font-badge font-bold tracking-widest text-sm uppercase mb-4 md:mb-8" data-id="element-118">
            <span className="text-xl" aria-hidden="true" data-id="element-119">
              🏃
            </span>{' '}
            P.E. READY
          </div>

          <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-heading pl-[0px] pr-[0px] mt-[-20px] mb-[-20px] leading-[0.95] pt-[10px] pb-[10px]" data-id="element-120">
            Your entire year of
            <br data-id="element-121" />
            <span className="text-brand-accent" data-id="element-122">
              Physical Education solved.
            </span>
          </h1>
        </div>

        <div className="w-full max-w-[230px] sm:max-w-xs md:max-w-md mx-auto relative mt-6 md:mt-12 mb-6 md:mb-12" data-id="element-123">
          <picture data-id="element-124">
            <source type="image/webp" srcSet="https://cdn.magicpatterns.com/uploads/955gdjCj7PrKELTNxNqLDG/image_(8).webp" data-id="element-125" />
            <img src="https://cdn.magicpatterns.com/uploads/955gdjCj7PrKELTNxNqLDG/image_(8).webp" alt="P.E. READY — The Ultimate PE Teacher Bundle, 6 complete volumes from beginner to advanced levels" className="w-full h-auto object-contain relative z-10 mt-[-5px] mb-[-10px]" loading="eager" fetchPriority="high" decoding="sync" width={385} height={385} data-id="element-126" />
          </picture>
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-127">
          <p className="text-base sm:text-lg md:text-2xl text-brand-muted leading-relaxed px-2 mb-6 md:mb-10 max-w-2xl" data-id="element-128">
            6 done-for-you volumes packed with lesson plans, skill progressions,
            assessment tools, and ready-to-run session plans. Plan your{' '}
            <span className="text-brand-ink font-bold" data-id="element-129">
              entire school year in one afternoon
            </span>{' '}
            — and{' '}
            <span className="text-brand-accent font-bold" data-id="element-130">
              reclaim your Sundays for good.
            </span>
          </p>

          <div className="flex flex-nowrap justify-center gap-1.5 md:gap-3 mb-6 md:mb-10 w-full mx-auto px-1" data-id="element-131">
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-brand-ink whitespace-nowrap" data-id="element-132">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-brand-ink whitespace-nowrap" data-id="element-133">
              ⚡ Instant Access
            </span>
            <span className="text-[10px] md:text-sm font-medium border border-brand-border bg-brand-card px-2 md:px-4 py-1 md:py-2 rounded-full text-brand-ink whitespace-nowrap" data-id="element-134">
              🌍 Global Teaching Standard
            </span>
          </div>

          <button onClick={() => {
          const TOP_OFFSET = 12;
          const DURATION = 1400;
          const startY = window.pageYOffset;
          const startTime = performance.now();
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          const getTarget = () => {
            const sec = document.getElementById('pricing');
            if (!sec) return null;
            return sec.getBoundingClientRect().top + window.pageYOffset - TOP_OFFSET;
          };
          const step = (now: number) => {
            const elapsed = now - startTime;
            const t = Math.min(1, elapsed / DURATION);
            const eased = easeInOutCubic(t);
            const target = getTarget();
            if (target == null) {
              if (elapsed < DURATION + 2000) requestAnimationFrame(step);
              return;
            }
            const y = startY + (target - startY) * eased;
            window.scrollTo(0, y);
            if (t < 1) {
              requestAnimationFrame(step);
            } else if (Math.abs(window.pageYOffset - target) > 1) {
              const settleStart = performance.now();
              const settleFromY = window.pageYOffset;
              const settleDur = 350;
              const settleStep = (n2: number) => {
                const e2 = n2 - settleStart;
                const t2 = Math.min(1, e2 / settleDur);
                const tgt2 = getTarget();
                if (tgt2 == null) return;
                window.scrollTo(0, settleFromY + (tgt2 - settleFromY) * easeInOutCubic(t2));
                if (t2 < 1) requestAnimationFrame(settleStep);
              };
              requestAnimationFrame(settleStep);
            }
          };
          requestAnimationFrame(step);
        }} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-white font-black text-xl md:text-3xl py-5 md:py-6 px-10 md:px-14 rounded-2xl transition-colors flex items-center justify-center mb-5 md:mb-8 mx-4 sm:mx-0 ml-[50px] mr-[50px] pl-[0px] pr-[0px]" data-id="element-135">
            → I WANT P.E. READY NOW
          </button>

          <div className="flex flex-wrap justify-center items-center gap-x-3 md:gap-x-5 gap-y-2 text-xs md:text-sm text-brand-muted font-semibold" data-id="element-136">
            <span className="flex items-center gap-1.5" data-id="element-137">
              <span className="text-brand-accent" data-id="element-138">🛡️</span> Satisfied or
              Refunded in 7 Days
            </span>
            <span className="text-brand-border" aria-hidden="true" data-id="element-139">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-140">
              <span className="text-brand-accent" data-id="element-141">🔒</span> Secure Payment
            </span>
            <span className="text-brand-border" aria-hidden="true" data-id="element-142">
              •
            </span>
            <span className="flex items-center gap-1.5" data-id="element-143">
              <span className="text-brand-accent" data-id="element-144">💳</span> One-time Payment
            </span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-145">
          <div className="text-center" data-id="element-146">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-147">
              +2,500
            </div>
            <div className="text-xs md:text-sm text-brand-muted font-medium uppercase tracking-wider" data-id="element-148">
              PE Teachers trust us
            </div>
          </div>
          <div className="text-center" data-id="element-149">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-150">
              6
            </div>
            <div className="text-xs md:text-sm text-brand-muted font-medium uppercase tracking-wider" data-id="element-151">
              Ready Volumes
            </div>
          </div>
          <div className="text-center" data-id="element-152">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-153">
              4.9/5 ⭐
            </div>
            <div className="text-xs md:text-sm text-brand-muted font-medium uppercase tracking-wider" data-id="element-154">
              Rating
            </div>
          </div>
          <div className="text-center" data-id="element-155">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-156">
              🌍
            </div>
            <div className="text-xs md:text-sm text-brand-muted font-medium uppercase tracking-wider" data-id="element-157">
              Worldwide Community
            </div>
          </div>
        </div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-158">
          {[{
          initials: 'MG',
          name: 'Marcus G.',
          loc: 'Sydney | Head PE Teacher',
          quote: "Finally, a resource that speaks the language of a real PE professional. I organized my entire school year's programming in a single afternoon. I never thought one resource could be this complete."
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Florida | Physical Education Teacher',
          quote: "My lessons finally have a solid, professional structure. I don't spend Sunday nights scrolling Pinterest anymore. Having everything ready gave me my free time back."
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Spain | Certified PE Specialist',
          quote: 'The system saved me. I never walked into class unprepared again. My students stay active, engaged, and actually excited about PE.'
        }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-159">
              <div className="flex items-center gap-3 mb-3" data-id="element-160">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/5 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-161">
                  {test.initials}
                </div>
                <span className="text-brand-gold text-sm" aria-label="5 stars" data-id="element-162">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <p className="text-brand-ink font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-163">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-brand-muted uppercase tracking-wider font-bold" data-id="element-164">
                — {test.name}, {test.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}